import {
  Component,
  Input,
  Directive, ContentChildren, QueryList, OnInit
} from '@angular/core';
import {NgbModal} from '../../modal/modal.module';


@Directive({selector: 'clo-notification-item'})
export class CloNotificationItem {
  /**
   *  If 'true' will not have a a red dot next to notification
   */
  @Input() read = false;


  /**
   *  The notification type
   *
   *  Available types include ['transit']
   */
  @Input() type: string;

  /**
   *  An image url to display next to the notification
   *
   */
  @Input() previewImage: string;

  /**
   *  The notification header
   */
  @Input() headerText: string;

  /**
   *  The notification message
   */
  @Input() message: string;


  /**
   * Details about the notification (cart information, etc.)
   */
  @Input() details: string;

  /**
   *  The time from the notification being created to now as a string (ex: '2 minutes ago')
   */
  @Input() time: string;
}

@Component({
  selector: 'clo-notifications',
  templateUrl: './notifications.html',
  styleUrls: ['./notifications.css']
})
export class CloNotifications implements OnInit {
  @ContentChildren(CloNotificationItem) items: QueryList<CloNotificationItem>;

  @Input() unread: boolean;

  constructor(private modalService: NgbModal) {}

  open(content) {
    this.modalService.open(content, {windowClass: 'headerModal notifications'});
  }

  ngOnInit() {
    // this.unread = (this.items.find(i => i.read === true)) ? true : false;
  }


}
